import { handleActions } from 'redux-actions';
import { apiModuleDefaultState, createApiActions } from './helpers';

export const actions = createApiActions('compliance');

const reducer = handleActions(
  {
    [actions.api.compliance.request]: () => ({
      isFetching: true,
      isError: false,
    }),
    [actions.api.compliance.response]: (_, { payload }) => ({
      isFetching: false,
      isError: false,
      data: payload,
    }),
    [actions.api.compliance.error]: (_, { payload }) => ({
      isFetching: false,
      isError: true,
      error: payload,
    }),
  },
  { ...apiModuleDefaultState, data: [], error: null }
);

export default reducer;
